import React from 'react';
import DatePicker from '../../DatePicker';
import { DatePickerSubheadProps } from '.';

const DatePickerSubheadDesktop: React.FC<DatePickerSubheadProps> = DatePicker;

export default DatePickerSubheadDesktop;
